import { render, staticRenderFns } from "./NotificationPublishtable.vue?vue&type=template&id=d2e2c4aa&scoped=true&"
import script from "./NotificationPublishtable.vue?vue&type=script&lang=js&"
export * from "./NotificationPublishtable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPublishtable.vue?vue&type=style&index=0&id=d2e2c4aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e2c4aa",
  null
  
)

export default component.exports